import { RefObject, useEffect } from 'react';

const MAX_FOCUS_ATTEMPTS = 30;

export function useFocusOnReady(
  containerRef: RefObject<HTMLElement | null>,
  enabled: boolean,
  selector = 'input[type="text"]',
) {
  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    let attempts = 0;
    let outerFrame: number;
    let innerFrame: number;

    const tryFocus = () => {
      if (cancelled) return;
      const el = containerRef.current?.querySelector<HTMLElement>(selector);
      if (el) {
        el.focus();
        if (document.activeElement === el) return;
      }
      if (attempts < MAX_FOCUS_ATTEMPTS) {
        attempts++;
        requestAnimationFrame(tryFocus);
      }
    };

    outerFrame = requestAnimationFrame(() => {
      innerFrame = requestAnimationFrame(tryFocus);
    });

    return () => {
      cancelled = true;
      cancelAnimationFrame(outerFrame);
      cancelAnimationFrame(innerFrame);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled]);
}
